import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Transactions stats DTO
 */
@CaslSubject(AppSubjectEnum.TRANSACTION)
export class TransactionsStatsDto extends BaseStatsDto {
  active!: number;
  cancelled!: number;
}
